/*================ Appreciation Masthead Factory
  ========================================*/
  angular.module("vppApp").factory("appreciationMastheadFactory", appreciationMastheadFactory);

  appreciationMastheadFactory.$inject = ["$http", "vppConfig", "$state"];
  
  function appreciationMastheadFactory($http, vppConfig, $state) {
    return function() {
      var Url = "/content/json/appreciationMasthead/" + vppConfig.folderPath + "/" + "index-static-content.json";
      var promise = $http.get(Url).then(
        function successCallback(data) {
          return data;
        },
        function errorCallback(data) {
          return data;
        }
      );
  
      return promise;
    };
  } 
  